/*
 * File: catalog-sync.component.ts                                             *
 * Project: catalog-cloud                                                      *
 * File Created: Tuesday, 28th December 2021 13:55:07                          *
 * Author: Tomás Muniesa (tomas@cege.es)                                       *
 * -----                                                                       *
 * Last Modified: Friday, 2nd December 2022 14:42:33                           *
 * Modified By: Tomás Muniesa (tomas@cege.es>)                                 *
 * -----                                                                       *
 * Copyright 2021 - 2022 Nousmedis, CeGe                                       *
 */

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CatalogService } from '../../../services/catalog.service';
import { Catalog } from '@nousmedis/cc-types';
import { MessageService } from 'primeng/api';
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-catalog-sync',
  templateUrl: './catalog-sync.component.html',
  styleUrls: ['./catalog-sync.component.scss'],
})
export class CatalogSyncComponent implements OnInit {
  idCatalog: string;
  @Output() syncFinish: EventEmitter<void> = new EventEmitter<void>();
  loadingReSync = false;
  saveButton = false;
  testConnectionShow: boolean = false;
  testConnectionIcon: string = '';
  testConnectionMessage: string = '';
  connectionStatus: boolean = false;
  catalog: Catalog;
  result: any = false;
  syncError: boolean = false;
  disableSync: boolean = false;

  reSyncData: { label: string; value: any }[] = [];

  sendSyncDataButton: boolean = true;
  showReSyncTable: boolean = false;
  startReSyncButton: boolean = false;

  loading = false;
  constructor(
    private catalogService: CatalogService,
    private messageService: MessageService,
    private dialogConfig: DynamicDialogConfig,
    private dialogRef: DynamicDialogRef,
    private translate: TranslateService
  ) {
    this.idCatalog = this.dialogConfig.data ? this.dialogConfig.data.id : '';
  }

  ngOnInit(): void {}

  // async syncro() {
  //   this.loading = true;
  //   this.result = null;
  //   this.syncError = false;
  //   this.catalogService
  //     .syncronizeSalesLayer(this.idCatalog)
  //     .subscribe((syncResume) => {
  //       this.loading = false;
  //       this.result = syncResume;

  //       if (syncResume == null) {
  //         this.syncError = true;
  //       } else {
  //         this.disableSync = true;
  //         this.syncFinish.next();
  //       }
  //     });
  // }

  reSync() {
    let id = this.idCatalog;
    this.loadingReSync = true;
    this.saveButton = true;

    this.catalogService.reSync(id).then(
      (res) => {
        this.reSyncData = Object.keys(res).map((key) => {
          return {
            label: key,
            value: res[key],
          };
        });

        //Verificar si los valores del get son 0
        const values = this.reSyncData.every((item) => {
          const { total, new: newItems, updated, deleted } = item.value;
          return (
            total === 0 && newItems === 0 && updated === 0 && deleted === 0
          );
        });

        if (values) {
          //Mostrar mensaje de que no hay datos por sincronizar
          this.messageService.add({
            severity: 'info',
            summary: 'Sin cambios',
            detail: this.translate.instant('SYNCWALL.NO_CHANGES'),
          });

          this.sendSyncDataButton = true;
          this.showReSyncTable = false;
          this.saveButton = false;
        } else {
          //mensaje de reSync exitoso
          this.messageService.add({
            severity: 'info',
            summary: 'info',
            detail: this.translate.instant('SYNCWALL.DATA_DOWNLOADED'),
          });

          this.loadingReSync = false;
          this.sendSyncDataButton = false;
          this.showReSyncTable = true;
        }
      },
      (err) => {
        console.error('Error:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: this.translate.instant('SYNCWALL.ERROR'),
        });

        this.loadingReSync = false;
        this.showReSyncTable = false;
      }
    );
  }

  sendSyncData() {
    let id = this.idCatalog;
    this.startReSyncButton = true;
    this.loadingReSync = true;
    this.saveButton = true;

    //convertir reSyncData a un objeto
    const tableData = this.reSyncData.reduce(
      (acc: { [key: string]: any }, item) => {
        acc[item.label] = item.value;
        return acc;
      },
      {}
    );

    this.catalogService
      .sendSyncData(id, tableData)
      .then((res) => {
        //mensaje de envío de datos exitoso
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: this.translate.instant('SYNC_OK'),
        });

        this.saveButton = false;
        this.loadingReSync = false;
        this.sendSyncDataButton = true;
        this.dialogRef.close();
      })
      .catch((err) => {
        console.error('Error:', err);

        //mensaje de error al enviar datos
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: this.translate.instant('SYNCWALL.SYNC_ERROR'),
        });

        this.loadingReSync = false;
        this.startReSyncButton = true;
        this.saveButton = true;
      });
  }
}
